import { GlAvatar, GlAvatarLink, GlButton, GlLink, GlTooltipDirective } from '@gitlab/ui';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { projectAutomateAgentSessionPath } from 'ee/lib/utils/path_helpers/project';
import { formatAgentFlowTitle, formatAgentFlowTitleTooltip, getNumericId } from 'ee/ai/duo_agents_platform/utils';
import { eventHub, SHOW_SESSION } from 'ee/ai/events/panel';
import TimeAgoTooltip from '~/vue_shared/components/time_ago_tooltip.vue';
import duoChatAvailableQuery from '../../graphql/duo_chat_available.query.graphql';
export default {
    name: 'AgentSessionRow',
    components: {
        GlAvatar,
        GlAvatarLink,
        GlButton,
        GlLink,
        TimeAgoTooltip
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        session: {
            type: Object,
            required: true
        },
        showViewDetails: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            duoChatAvailable: false
        };
    },
    apollo: {
        duoChatAvailable: {
            query: duoChatAvailableQuery,
            update (data) {
                return data?.currentUser?.duoChatAvailable ?? false;
            },
            error () {
                this.duoChatAvailable = false;
            }
        }
    },
    computed: {
        numericId () {
            return getIdFromGraphQLId(this.session.id);
        },
        sessionUrl () {
            const fullPath = this.session.project?.fullPath;
            return fullPath ? projectAutomateAgentSessionPath(fullPath, this.numericId) : null;
        },
        title () {
            return formatAgentFlowTitle(this.session.title, this.session.workflowDefinition);
        },
        canOpenSession () {
            return Boolean(this.sessionUrl) || this.duoChatAvailable;
        },
        titleComponent () {
            if (this.sessionUrl) return GlLink;
            return this.duoChatAvailable ? GlButton : 'span';
        },
        titleAttributes () {
            if (this.sessionUrl) return {
                href: this.sessionUrl
            };
            return this.duoChatAvailable ? {
                variant: 'link',
                buttonTextClasses: 'gl-truncate'
            } : {
                tabindex: 0
            };
        },
        titleTooltip () {
            return formatAgentFlowTitleTooltip(this.title, this.numericId);
        },
        user () {
            return this.session.user || null;
        },
        userId () {
            return getNumericId(this.user?.id);
        }
    },
    methods: {
        openSession (event) {
            if (!this.duoChatAvailable) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey) return;
            event.preventDefault();
            eventHub.$emit(SHOW_SESSION, {
                id: this.numericId
            });
        }
    }
};
